import { 
	createSlice
} from '@reduxjs/toolkit'

const poseCamSlice = createSlice({
	name: 'poseCam',
	initialState:{
		show:false,
		currentPose:1,
		date: new Date().toLocaleString()
	},
	reducers: {
		toggleShow : (state,action)=>{
			state.show = action.payload
		},
		setPose : (state,action)=>{
			state.currentPose = action.payload
		},
		setDate : (state,action)=>{
			state.date = action.payload
		},
		showWithSettings : (state,action)=>{
			state.show = true
			state.currentPose = action.payload.currentPose
			state.date = action.payload.date
		}
	}
})

export const {toggleShow,setPose,showWithSettings,setDate} = poseCamSlice.actions


export default poseCamSlice.reducer